import { render, staticRenderFns } from "./MpMenu.vue?vue&type=template&id=c36aedc4&scoped=true&"
import script from "./MpMenu.vue?vue&type=script&lang=js&"
export * from "./MpMenu.vue?vue&type=script&lang=js&"
import style0 from "./MpMenu.vue?vue&type=style&index=0&id=c36aedc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36aedc4",
  null
  
)

export default component.exports